import dayjs from 'dayjs';

export const BALANCE_ANCHOR_ID = 'balance';

export const formatMoney = (cents) => `$${((cents || 0) / 100).toFixed(2)}`;

// Due dates arrive as 'YYYY-MM-DD' (no time component).
export const formatDueDate = (value) => (value ? dayjs(value).format('ddd, MMM D, YYYY') : '');

export const formatDateTime = (value) => (value ? dayjs(value).format('ddd, MMM D, YYYY h:mm a') : '');

export const balanceProfilePath = (userTenantId) => (userTenantId ? `/player/${userTenantId}#${BALANCE_ANCHOR_ID}` : null);

export const invoiceLabel = (invoice) =>
  invoice.title || (invoice.invoiceNumber ? `Invoice #${invoice.invoiceNumber}` : 'Invoice');
